import { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setTabOnFocus } from '../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getTabOnFocus } from '../../store/global/selectors';
import { Grid } from '@material-ui/core';
import Page from '../atoms/page';
import UndoRedoList from '../molecules/UndoRedo/UndoRedoList';

export default function UndoRedoTabs(props) {
    const dispatch = useDispatch();
    const tabOnFocus = useSelector(getTabOnFocus);
    const [openTab, setOpenTab] = useState(0);
    const [response, setResponse] = useState({status: false, message: "Another user owns the last action in the blueprint"});

    
    useEffect(() => {
        setOpenTab(tabOnFocus);
        setResponse(null);
    }, [tabOnFocus])

    useEffect(() => {
       setResponse({status: false, message: "Another user owns the last action in the blueprint"});
    }, []);



    return (
        <Page title="Undo/Redo" style={{ marginTop123: "-64px" }}>
            <Grid container direction={"row"}>
                <AppBar position="static">
                    <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="UndoRedoTabs">
                        <Tab label="Undo" id="undo" style={{textTransform: 'capitalize'}} />
                        <Tab label="Redo" id="redo" style={{textTransform: 'capitalize'}} />
                    </Tabs>
                </AppBar>


                <TabPanel value={openTab} index={0} style={{width: '100%'}}>
                    <UndoRedoList action="undo" response={response} setResponse={setResponse}/>
                </TabPanel>

                <TabPanel value={openTab} index={1} style={{width: '100%'}}>
                    <UndoRedoList action="redo" response={response} setResponse={setResponse}/>
                </TabPanel>

            </Grid>
        </Page>
    )
}